<template>
  <div class="container mx-auto mt-16 px-4 pb-20">
    <h1 class="font-bold text-4xl mb-8">
      {{ isNew ? "New post" : "Editing post" }}
    </h1>

    <FormErrors :errors="errors" subject="post" />

    <form @submit.prevent="submit">
      <div class="flex flex-col gap-5 my-5">
        <div>
          <Label for="post_title">Title</Label>
          <Input
            id="post_title"
            v-model="form.title"
            type="text"
            class="mt-2"
          />
        </div>

        <div>
          <Label for="post_body">Body</Label>
          <textarea
            id="post_body"
            v-model="form.body"
            class="mt-2 flex w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring h-48"
          />
        </div>
      </div>

      <div class="mt-8 flex gap-4">
        <Button type="submit" :disabled="form.processing">
          {{ isNew ? "Create post" : "Update post" }}
        </Button>
        <Button as="a" :href="postsPath" variant="outline">
          Back to posts
        </Button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useForm } from "@inertiajs/vue3";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import FormErrors from "@/components/form/FormErrors.vue";

const props = defineProps({
  post: { type: Object, required: true },
  currentUser: { type: Object, default: null },
  actionPath: { type: String, required: true },
  postsPath: { type: String, required: true },
  postPath: { type: String, default: "" },
  errors: { type: Array, default: () => [] },
});

const isNew = computed(() => !props.post.id);

const form = useForm({
  title: props.post.title ?? "",
  body: props.post.body ?? "",
});

function submit() {
  if (isNew.value) {
    form.post(props.actionPath);
  } else {
    form.patch(props.actionPath);
  }
}
</script>
